import React from 'react';
import { LogoAmazon } from '@ghosts-inc/design-system/icons';
import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

export const AmazonCircleIcon = ({
  sx,
  small = false,
}: {
  sx: SxProps<Theme>;
  small?: boolean;
}) => {
  return (
    <Box
      data-testid="amazon-icon"
      bgcolor={'#FFCCAE'}
      borderRadius={25}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      width={small ? 16 : 24}
      height={small ? 16 : 24}
      margin="auto"
      sx={sx}
    >
      <LogoAmazon width={small ? 12 : 18} height={small ? 12 : 18} />
    </Box>
  );
};
